export const GO_BACK_TEXT = 'GO BACK TO HOME PAGE';
export const GO_TO_HOMEPAGE = 'Go to Homepage';
export const NOT_FOUND_IMAGE =
  'https://images-static.nykaa.com/uploads/3e28e814-3166-4b38-982c-f8897909f304.jpg?tr=w-600,cm-pad_resize';
export const NOT_FOUND_IMAGE_V2 =
  'https://images-static.nykaa.com/media/PageNotFound.jpg?tr=w-600,cm-pad_resize';
export const POPULAR_BRAND = 'popular-brands';
export const POPULAR_BRNAD2 = 'popular-brands2';
export const NOT_FOUND_TEXT = 'Sorry! Page not found';
export const ERROR_TEXT = 'Sorry, Something went wrong!';
export const NOT_FOUND_SUBTEXT =
  'The page you are looking for has been moved or deleted';
export const NOT_FOUND_SUBTEXT_V2 = 'Try Searching 🔍 or go to homepage';
export const FETCH_ERROR = 'Error in Fetch Widgets service';
export const FETCH_ACTION_ERROR = 'Error in Fetch Widgets action';
